import { render, staticRenderFns } from "./CounselFormReg.vue?vue&type=template&id=97adadb8&scoped=true"
import script from "./CounselFormReg.vue?vue&type=script&lang=js"
export * from "./CounselFormReg.vue?vue&type=script&lang=js"
import style0 from "./CounselFormReg.vue?vue&type=style&index=0&id=97adadb8&prod&lang=styl&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97adadb8",
  null
  
)

export default component.exports